/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

import { withBrandIcon, type BrandIcon } from '../../../icons/with-brand-icon';

const OfficialIcon = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "@atlassian/logo-third-party/salesforce" */ '@atlassian/logo-third-party/salesforce'
		).then((m) => m.SalesforceIcon),
	{ moduleId: '@atlassian/logo-third-party/salesforce' },
);

const LazyForgePioSalesforceIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-pio-salesforce-prod" */ './utils').then(
			(m) => m.ForgePioSalesforceIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-pio-salesforce-prod/icon' },
);

const LazyForgePioSalesforceSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-forge-pio-salesforce-prod-search-result" */ './utils').then(
			(m) => m.ForgePioSalesforceSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/forge-pio-salesforce-prod/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const ForgePioSalesforceIcon: BrandIcon = withBrandIcon(
	(): React.JSX.Element => (
		<Suspense fallback={null}>
			<LazyForgePioSalesforceIconComponent />
		</Suspense>
	),
	OfficialIcon,
	'small',
);

export const ForgePioSalesforceSearchResultIcon: BrandIcon = withBrandIcon(
	(): React.JSX.Element => (
		<Suspense fallback={null}>
			<LazyForgePioSalesforceSearchResultIconComponent />
		</Suspense>
	),
	OfficialIcon,
	'medium',
);
